import { useEffect, useState } from 'react';

const useShortenerResolutionReloadDomains = ({
  customerId,
  filtersSelected,
  isLoadedDomains,
  shortenerResolutionFetchDomains,
}) => {
  const customerIdToFetch = filtersSelected.filterByCustomer
    ? customerId
    : undefined;

  const [prevCustomerIdToFetch, setPrevCustomerIdToFetch] = useState(
    customerIdToFetch
  );

  useEffect(() => {
    setPrevCustomerIdToFetch(customerIdToFetch);
  }, [customerIdToFetch]);

  useEffect(() => {
    const mustReload =
      isLoadedDomains && customerIdToFetch !== prevCustomerIdToFetch;

    if (mustReload) {
      shortenerResolutionFetchDomains({
        customerId: customerIdToFetch,
      });
    }
  }, [
    customerIdToFetch,
    prevCustomerIdToFetch,
    isLoadedDomains,
    shortenerResolutionFetchDomains,
  ]);
};

export default useShortenerResolutionReloadDomains;
